import React, {PropTypes as T} from 'react';
import Modal, {ModalHeader, ModalContent, ModalFooter} from '../../common/modal';
import Button from '../../common/button';
import TU from '../../common/tu';
import SadTicketIcon from '../../common/icons/icon_sad_ticket';
import ModalCautionIcon from '../../common/icons/icon_modal_caution';
import ModalCloseIcon from '../../common/icons/icon_close2';
import withDevice from '../../common/withDeviceHOC';
import {translate} from '../../../utils/utils';

export class SeatmapMemberLimitErrorModal extends React.Component {
  static propTypes = {
    translations: T.object,
    onClose: T.func,
    memberTicketLimit: T.number.isRequired,
    isMobile: T.bool
  };

  static defaultProps = {
    onClose: Function.prototype
  };

  state = { isOpen: true };

  closeModal = () => {
    this.setState({ isOpen: false });
    setTimeout(this.props.onClose, 500);
  };

  render () {
    const trans = this.props.translations;
    const memberTicketLimitError = this.props.memberTicketLimit
        ? translate(trans.MEMBER_LIMIT_ERROR_EXCEEDED, {'%LIMIT%': `${this.props.memberTicketLimit}`})
        : trans.MEMBER_LIMIT_ERROR_INFO;
    return (
      <Modal dataComponent="member-ticket-limit-error-modal" isOpen={this.state.isOpen}>
        <ModalHeader isError>
          <div className="modal__header__icon__wrapper">
            <ModalCautionIcon className="modal__header__icon" />
          </div>
          <div className="modal__header_title">{trans.MEMBER_LIMIT_ERROR_HEADER_SHORT}</div>
          <Button icon onClick={this.closeModal}>
            <ModalCloseIcon className="modal__header__close_icon" />
          </Button>
        </ModalHeader>
        <ModalContent>
          <SadTicketIcon className="modal__sad_ticket_icon" />
          <TU text={memberTicketLimitError} tag="div" />
        </ModalContent>
        <ModalFooter>
          <Button
            data-component="change-selection-button"
            primary
            onClick={this.closeModal}
            flex={this.props.isMobile}>{trans.CHANGE_SELECTION_BUTTON}</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default withDevice(SeatmapMemberLimitErrorModal);



// WEBPACK FOOTER //
// ./frontend/react/components/edp/errors/member_ticket_limit_error.js